export default "__VITE_ASSET__BFKQiSSQ__"